export default {
      id: "common__status_not_show-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__status_not_show",
      toString: function () {
        return this.url;
      }
    }